// extracted by mini-css-extract-plugin
module.exports = {"comp":"OnePicture_comp__nGp7o"};